import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { Roles } from '../shared/Enums/Roles.enum';
import Keycloak from 'keycloak-js';

const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  __: RouterStateSnapshot,
  authData: AuthGuardData,
): Promise<boolean | UrlTree> => {
  const { authenticated, grantedRoles } = authData;
  const keycloak = inject(Keycloak);
  const router = inject(Router);

  if(!authenticated || !grantedRoles.resourceRoles['portal-app']) {
    keycloak.clearToken();
    return keycloak.login().then(() => false);
  }

  if(grantedRoles.resourceRoles['portal-app'].some(x => x.includes(Roles.PortalUserNotBinded))) {
    router.navigate(['case-assignment']);
    return false;
  }

  const requiredRole = route.data['role'];
  if(!grantedRoles.resourceRoles['portal-app'].some(x => x.includes(requiredRole))) {
    router.navigate(['forbidden']);
    return false;
  }
  return true;
};

export const canActivateAuthRole = createAuthGuard<CanActivateFn>(isAccessAllowed);